// extracted by mini-css-extract-plugin
export default {"tabs":"TabSelector_tabs__0lzb7","tab":"TabSelector_tab__3eSWV","is-selected":"TabSelector_is-selected__RVw-B"};